__turbopack_context__.v({
  "barButton": "PLBottomBar-module__TRLm7q__barButton",
  "bookingInfo": "PLBottomBar-module__TRLm7q__bookingInfo",
  "bottomBarContainer": "PLBottomBar-module__TRLm7q__bottomBarContainer",
  "buttonRow": "PLBottomBar-module__TRLm7q__buttonRow",
  "cartItemCount": "PLBottomBar-module__TRLm7q__cartItemCount",
  "cartOriginalTotal": "PLBottomBar-module__TRLm7q__cartOriginalTotal",
  "cartTotal": "PLBottomBar-module__TRLm7q__cartTotal",
  "desktopRow": "PLBottomBar-module__TRLm7q__desktopRow",
  "mobileColumn": "PLBottomBar-module__TRLm7q__mobileColumn",
  "mobileTopRow": "PLBottomBar-module__TRLm7q__mobileTopRow",
  "rightGroup": "PLBottomBar-module__TRLm7q__rightGroup",
  "slideUp": "PLBottomBar-module__TRLm7q__slideUp",
});
